module.exports = __webpack_public_path__ + "img/shouldertofootlength.8bd4da09.jpeg";